var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.586 2.66675H10.426C5.55935 2.66675 2.66602 5.56008 2.66602 10.4134V21.5734C2.66602 26.4268 5.55935 29.3201 10.4127 29.3201H21.5727C26.426 29.3201 29.3193 26.4268 29.3193 21.5734V10.4134C29.3327 5.56008 26.4393 2.66675 21.586 2.66675Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5734 8.1333C13.0268 8.1333 12.5734 8.58663 12.5734 9.1333V20.4666L10.2268 18.12C9.8401 17.7333 9.2001 17.7333 8.81344 18.12C8.42677 18.5066 8.42677 19.1466 8.81344 19.5333L12.8668 23.5866C12.9601 23.68 13.0668 23.7466 13.1868 23.8C13.3068 23.8533 13.4401 23.88 13.5734 23.88C13.7068 23.88 13.8268 23.8533 13.9601 23.8C14.2001 23.6933 14.4001 23.5066 14.5068 23.2533C14.5601 23.1333 14.5868 23 14.5868 22.8666V9.1333C14.5734 8.5733 14.1334 8.1333 13.5734 8.1333Z",
    fill: "#111111",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1877 12.48L19.1344 8.42663C19.0411 8.3333 18.9344 8.26663 18.8144 8.2133C18.5744 8.10663 18.2944 8.10663 18.0544 8.2133C17.8144 8.31997 17.6144 8.50663 17.5077 8.75997C17.4544 8.87997 17.4277 9.0133 17.4277 9.14663V22.8933C17.4277 23.44 17.8811 23.8933 18.4277 23.8933C18.9744 23.8933 19.4277 23.44 19.4277 22.8933V11.56L21.7744 13.9066C21.9744 14.1066 22.2277 14.2 22.4811 14.2C22.7344 14.2 22.9877 14.1066 23.1877 13.9066C23.5744 13.4933 23.5744 12.8666 23.1877 12.48Z",
    fill: "#111111",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.08570fd4b807969d466b2a62d72a8e66.svg";
export { ForwardRef as ReactComponent };